import { InputNumber as AntInputNumber, InputNumberProps as AntInputNumberProps, Skeleton } from 'antd';
import { FC } from 'react';

export type ValueType = string | number;

export interface InputNumberProps<T extends ValueType = ValueType> extends AntInputNumberProps<T> {
  isLoading?: boolean;
}

export const InputNumber = <T extends ValueType = ValueType>({
  isLoading,
  parser = value => value?.replace(',', '.') as unknown as T,
  ...props
}: InputNumberProps<T>): ReturnType<FC<InputNumberProps<T>>> => {
  if (isLoading) return <Skeleton.Input active block />;

  return <AntInputNumber parser={parser} {...props} />;
};
